export interface KujoProduct {
  slug: string;
  name: string;
  category: "Footwear" | "Apparel" | "Accessories";
  tagline: string;
  description: string;
  image: string;
  features: string[];
  specs: { label: string; value: string }[];
  storeUrl: string;
}

export const kujoProducts: KujoProduct[] = [
  {
    slug: "yard-shoe",
    name: "Kujo Yard Shoe",
    category: "Footwear",
    tagline: "The original landscaping shoe",
    description:
      "The shoe that started it all. The Kujo Yard Shoe combines the comfort of an athletic sneaker with the durability of a work boot. Perfect for mowing, trimming, and everyday yard work. Breathable mesh keeps feet cool while the aggressive outsole grips turf and uneven terrain.",
    image: "https://cloud.kujo.com/YardShoe-4348700fb1.jpg",
    features: [
      "Anti-fatigue EVA midsole for all-day comfort",
      "Flex-groove rubber outsole for superior traction",
      "Breathable air mesh upper keeps feet cool",
      "Reinforced toe cap for protection",
      "Water-resistant SPU window blocks morning dew",
    ],
    specs: [
      { label: "Upper", value: "Air mesh with SPU window" },
      { label: "Midsole", value: "EVA anti-fatigue" },
      { label: "Outsole", value: "Rubber flex-groove" },
      { label: "Weight", value: "Lightweight athletic feel" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "x1-landscape-boot",
    name: "X1 Landscape Boot",
    category: "Footwear",
    tagline: "Heavy-duty protection for the toughest jobs",
    description:
      "When the job demands more, the X1 delivers. A 6-inch boot built for hardscaping, heavy brush clearing, and rugged terrain. Provides ankle support, increased water resistance, and rugged protection where you need it most.",
    image: "https://cloud.kujo.com/X1-79c69cacae.jpg",
    features: [
      "6-inch ankle support for uneven ground",
      "Enhanced waterproofing for wet conditions",
      "Heavy-duty toe guard for impact protection",
      "Durable construction for hardscape work",
      "Aggressive lug outsole for maximum grip",
    ],
    specs: [
      { label: "Height", value: "6-inch" },
      { label: "Upper", value: "Reinforced with waterproof membrane" },
      { label: "Outsole", value: "Aggressive lug rubber" },
      { label: "Protection", value: "Heavy-duty toe guard" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-jax",
    name: "Kujo Jax",
    category: "Footwear",
    tagline: "Agility meets durability",
    description:
      "The Kujo Jax is built for the landscaper who needs speed and agility without sacrificing protection. A lighter, more flexible option that moves with you through long days on the turf.",
    image: "https://cloud.kujo.com/Jax-126b96bf1e.jpg",
    features: [
      "Lightweight flexible construction",
      "Breathable mesh upper",
      "Shock-absorbing midsole",
      "Durable rubber outsole",
      "Reinforced toe protection",
    ],
    specs: [
      { label: "Upper", value: "Breathable mesh" },
      { label: "Midsole", value: "Shock-absorbing" },
      { label: "Outsole", value: "Durable rubber" },
      { label: "Weight", value: "Ultra-lightweight" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "surge-rubber-boot",
    name: "Surge Rubber Boot",
    category: "Footwear",
    tagline: "100% waterproof for the wettest conditions",
    description:
      "When the job is wet, muddy, and messy, the Surge Rubber Boot keeps you dry and moving. Fully waterproof construction with the comfort features landscapers expect from Kujo.",
    image: "https://cloud.kujo.com/Surge-9b676a24ea.jpg",
    features: [
      "100% waterproof rubber construction",
      "Moisture-wicking interior lining",
      "Cushioned anti-fatigue footbed",
      "Self-cleaning outsole design",
      "Easy on/off pull tabs",
    ],
    specs: [
      { label: "Material", value: "100% waterproof rubber" },
      { label: "Lining", value: "Moisture-wicking" },
      { label: "Footbed", value: "Cushioned anti-fatigue" },
      { label: "Outsole", value: "Self-cleaning" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-landscape-boot",
    name: "Kujo Landscape Boot",
    category: "Footwear",
    tagline: "The all-purpose workhorse",
    description:
      "A versatile boot designed for the full range of landscaping tasks. From planting to hardscaping, the Kujo Landscape Boot delivers the support, comfort, and durability that professional crews demand.",
    image: "https://cloud.kujo.com/X4S-472e41ceb3.jpg",
    features: [
      "Versatile all-day comfort",
      "Water-resistant construction",
      "Durable reinforced upper",
      "Cushioned support midsole",
      "Slip-resistant outsole",
    ],
    specs: [
      { label: "Upper", value: "Reinforced water-resistant" },
      { label: "Midsole", value: "Cushioned support" },
      { label: "Outsole", value: "Slip-resistant rubber" },
      { label: "Use", value: "All-purpose landscaping" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-yard-pants",
    name: "Kujo Yard Pants",
    category: "Apparel",
    tagline: "Built for the grind",
    description:
      "Durable work pants designed specifically for landscaping professionals. Reinforced in all the right places, with the mobility and comfort needed for long days in the yard.",
    image: "https://cloud.kujo.com/Pants_GlamourShots_ForWeb_v2-228322d024.jpg",
    features: [
      "Reinforced knee panels for durability",
      "Moisture-wicking fabric technology",
      "Articulated knees for freedom of movement",
      "Multiple utility pockets",
      "Abrasion-resistant construction",
    ],
    specs: [
      { label: "Material", value: "Durable performance fabric" },
      { label: "Knees", value: "Reinforced panels" },
      { label: "Pockets", value: "Multiple utility" },
      { label: "Fit", value: "Articulated work fit" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-dryflex-pants",
    name: "Kujo DryFlex Pants",
    category: "Apparel",
    tagline: "Stay dry, stay moving",
    description:
      "Water-resistant work pants that keep you dry without trapping heat. The DryFlex technology repels water while maintaining breathability, perfect for early morning dew or light rain conditions.",
    image: "https://cloud.kujo.com/DryFlex_GlamourShots_ForWeb-e9d151cebd.jpg",
    features: [
      "DryFlex water-repellent technology",
      "Breathable moisture-wicking fabric",
      "Reinforced stress points",
      "Flexible stretch construction",
      "Quick-drying material",
    ],
    specs: [
      { label: "Technology", value: "DryFlex water-repellent" },
      { label: "Material", value: "Breathable stretch fabric" },
      { label: "Drying", value: "Quick-dry" },
      { label: "Reinforcement", value: "Stress-point reinforced" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-sunflex-long-sleeve",
    name: "Kujo Sunflex - Long Sleeve",
    category: "Apparel",
    tagline: "Sun protection that moves with you",
    description:
      "UPF-rated sun protection in a lightweight, flexible long-sleeve shirt. Designed for landscapers who spend long hours under the sun, the Sunflex keeps you cool and protected all day.",
    image: "https://cloud.kujo.com/Header_KSF-N_1000x650-a8f0a477b8.jpg",
    features: [
      "UPF 50+ sun protection rating",
      "Lightweight breathable fabric",
      "Moisture-wicking technology",
      "Stretch construction for mobility",
      "Quick-drying performance material",
    ],
    specs: [
      { label: "Protection", value: "UPF 50+" },
      { label: "Material", value: "Lightweight performance fabric" },
      { label: "Technology", value: "Moisture-wicking" },
      { label: "Fit", value: "Active stretch fit" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-tech-hat",
    name: "Kujo Tech Hat",
    category: "Accessories",
    tagline: "Cool head, hard work",
    description:
      "A performance tech hat built for the jobsite. Breathable, moisture-wicking, and designed to keep the sun out of your eyes during long days on the yard.",
    image: "https://cloud.kujo.com/AE013715-70673b7acf.jpg",
    features: [
      "Moisture-wicking sweatband",
      "Breathable mesh panels",
      "Adjustable closure for custom fit",
      "UPF sun protection",
      "Durable structured front panels",
    ],
    specs: [
      { label: "Material", value: "Performance tech fabric" },
      { label: "Sweatband", value: "Moisture-wicking" },
      { label: "Closure", value: "Adjustable" },
      { label: "Protection", value: "UPF rated" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-yard-shorts",
    name: "Kujo Yard Shorts",
    category: "Apparel",
    tagline: "Summer-ready work shorts",
    description:
      "When the heat is on, the Kujo Yard Shorts deliver. Built with the same durability as the Yard Pants but in a breathable short design for hot summer days on the job.",
    image:
      "https://cloud.kujo.com/Shorts_GlamourShots_ForWeb_r1-57fdd7e170.jpg",
    features: [
      "Durable work-grade fabric",
      "Reinforced stress points",
      "Multiple utility pockets",
      "Freedom of movement design",
      "Moisture-wicking technology",
    ],
    specs: [
      { label: "Material", value: "Durable work fabric" },
      { label: "Length", value: "Work-length inseam" },
      { label: "Pockets", value: "Multiple utility" },
      { label: "Technology", value: "Moisture-wicking" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-sunflex-hoodie",
    name: "Kujo Sunflex - Hoodie",
    category: "Apparel",
    tagline: "Sun protection with full coverage",
    description:
      "The Sunflex Hoodie combines UPF sun protection with a lightweight hood for full coverage. Perfect for long days when you need maximum sun protection without overheating.",
    image: "https://cloud.kujo.com/Header_KSF-N_1000x650-a8f0a477b8.jpg",
    features: [
      "UPF 50+ sun protection",
      "Lightweight hooded design",
      "Moisture-wicking performance fabric",
      "Stretch construction for mobility",
      "Quick-drying material",
    ],
    specs: [
      { label: "Protection", value: "UPF 50+" },
      { label: "Style", value: "Lightweight hoodie" },
      { label: "Material", value: "Performance stretch fabric" },
      { label: "Technology", value: "Moisture-wicking quick-dry" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "kujo-yard-socks",
    name: "Kujo Yard Socks",
    category: "Accessories",
    tagline: "The foundation of comfort",
    description:
      "Performance work socks designed to pair perfectly with Kujo footwear. Cushioned where you need it, breathable where it counts, and built to last through the toughest work days.",
    image: "https://cloud.kujo.com/BlackSocks01-8b75717cfa.jpg",
    features: [
      "Targeted cushioning in high-impact zones",
      "Moisture-wicking fiber blend",
      "Reinforced heel and toe",
      "Arch support compression",
      "Breathable mesh ventilation",
    ],
    specs: [
      { label: "Material", value: "Performance fiber blend" },
      { label: "Cushioning", value: "Targeted high-impact" },
      { label: "Support", value: "Arch compression" },
      { label: "Reinforcement", value: "Heel and toe" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
  {
    slug: "flannel-lined-pants",
    name: "Flannel-Lined Pants",
    category: "Apparel",
    tagline: "Cold-weather work comfort",
    description:
      "When winter landscaping calls, the Flannel-Lined Pants answer. Built with a warm flannel interior and durable work-grade exterior, these pants keep you warm and productive in cold conditions.",
    image: "https://cloud.kujo.com/pants-khaki-s7-full-bbe37b9c2f.jpg",
    features: [
      "Warm flannel interior lining",
      "Durable water-resistant exterior",
      "Reinforced knee panels",
      "Multiple utility pockets",
      "Wind-resistant construction",
    ],
    specs: [
      { label: "Lining", value: "Warm flannel" },
      { label: "Exterior", value: "Water-resistant work fabric" },
      { label: "Reinforcement", value: "Knee panels" },
      { label: "Season", value: "Cold weather" },
    ],
    storeUrl:
      "https://store.911sourcing.com/products-list/collections/kujo-yardwear",
  },
];

export const getProductBySlug = (slug: string) =>
  kujoProducts.find((p) => p.slug === slug);
